import React from 'react'
import PropTypes from 'prop-types'
import config from '../../config'
import {
  Segment,
  Container,
  Grid,
  Message,
  Divider
} from 'semantic-ui-react'

const propTypes = {
  pageData: PropTypes.object.isRequired
}

const Kontakt = () => {
  const { email, phone, gsm, naslov } = config
 
  return (
    <div>
      <Segment basic>
        <Container>
          <Grid columns="three" stackable divided padded>
            <Grid.Row>
              <Grid.Column width={8}>

              <Message
                  color="grey"
                  icon="mobile alternate"
                  header="Pokličite nas - gsm:"
                  content={gsm}
                />
                <Message
                  color="grey"
                  icon="phone"
                  header="Pokličite nas - tel.:"
                  content={phone}
                />
                <Message
                  color="grey"
                  icon="mail"
                  header="Pošljite nam sporočilo"
                  content={email}
                />
                <Message
                  color="grey"
                  icon="address card outline"
                  header="Naslov"
                  content={naslov}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <Divider />
        </Container>
      </Segment>
    </div>
  )
}

Kontakt.propTypes = propTypes
export default Kontakt



// WEBPACK FOOTER //
// ./src/pages/kontakt/Kontakt.js